/**
 * Join class names, dropping falsy entries.
 *
 * Deliberately three lines rather than a dependency: `clsx` is only present
 * transitively here, and this is all of its API that we use. Note it does NOT
 * resolve Tailwind conflicts the way `tailwind-merge` would — a `className`
 * passed by a caller is appended, so it wins by source order only if it comes
 * later in the generated stylesheet. Where a prop must reliably override a
 * base style, branch on the prop instead of relying on append order.
 */
export const cn = (...parts) => parts.filter(Boolean).join(' ');

export default cn;
